import React from 'react'
import { TablePagination } from '@mui/material'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'

export const PAGE_SIZES = [10, 20, 50, 100]

type LocationsPaginationProps = {
  /** 1-based, as paginate() returns it */
  page: number
  pageSize: number
  matchingCount: number
  isFiltered: boolean
  /** 1-based */
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

/** MUI's TablePagination, shared by the table and the chips views */
const LocationsPagination: React.FC<LocationsPaginationProps> = ({
  page,
  pageSize,
  matchingCount,
  isFiltered,
  onPageChange,
  onPageSizeChange,
}) => {
  const t = useAppTranslations()

  return (
    <TablePagination
      component="div"
      count={matchingCount}
      page={matchingCount === 0 ? 0 : page - 1}
      rowsPerPage={pageSize}
      rowsPerPageOptions={PAGE_SIZES}
      onPageChange={(_, zeroBasedPage) => onPageChange(zeroBasedPage + 1)}
      onRowsPerPageChange={(event) => onPageSizeChange(Number(event.target.value))}
      labelRowsPerPage={t('adgroup.geoTargeting.panel.rowsPerPage')}
      labelDisplayedRows={({ from, to, count }) =>
        t(isFiltered ? 'adgroup.geoTargeting.panel.rangeMatching' : 'adgroup.geoTargeting.panel.range', {
          from,
          to,
          count,
        })
      }
      sx={{ borderTop: 1, borderColor: 'divider' }}
    />
  )
}

export default LocationsPagination
